import type { PropsWithChildren } from "react";

import { twMerge } from "tailwind-merge";

export function Missing({ className, children }: PropsWithChildren<{ className?: string }>) {
  return (
    <div
      className={twMerge(
        "rounded-sm border border-dashed border-divider bg-black/1 p-4 font-disinterest text-placeholder",
        className,
      )}
    >
      {children}
    </div>
  );
}
